import { Route } from '@angular/router';
import { AccountComponent } from './account.component';

export const AccountRoutes: Route[] = [
  {
    path: 'account',
    component: AccountComponent
  }
];
